import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { updateUserProfile } from "../../../utils/userApi";

const SocialForm = ({ onCancel, setStatusModal }) => {
  const { user, updateUser } = useAuth();

  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    platform: user?.socialMedia?.platform || "",
    link: user?.socialMedia?.link || "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.platform || !formData.link) {
      // alert("Please fill all fields");
      setError("Please fill all fields");
      return;
    }

    setError("");

    try {
      const res = await updateUserProfile(
        {
          socialMedia: formData, // ✅ matches backend
        },
        user.token,
      );

      updateUser(res.user);

      setStatusModal({
        open: true,
        type: "success",
        message: "Social Media Updated",
        subtext: "Your social media has been updated successfully.",
      });
      onCancel();
    } catch (err) {
      console.error(err);

      setStatusModal({
        open: true,
        type: "error",
        message: "Error Updating Social Media",
        subtext:
          "There was an error updating your social media. Please try again.",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="edit-form-card">
      <div className="form-group">
        <label>Platform</label>
        <select
          name="platform"
          className="social-input-field"
          value={formData.platform}
          onChange={handleChange}
        >
          <option value="">Select platform</option>
          <option value="x">X (Twitter)</option>
          <option value="instagram">Instagram</option>
          <option value="facebook">Facebook</option>
          <option value="linkedin">LinkedIn</option>
        </select>
      </div>
      {error && <p className="form-error">{error}</p>}
      <div className="form-group">
        <label>Profile Link</label>
        <input
          name="link"
          value={formData.link}
          onChange={handleChange}
          placeholder="https://..."
        />
      </div>

      <div className="form-actions">
        <button type="button" className="edit-cancel-btn" onClick={onCancel}>
          Cancel
        </button>

        <button type="submit" className="edit-primary-btn">
          Save
        </button>
      </div>
      {error && <p className="form-error">{error}</p>}
    </form>
  );
};

export default SocialForm;
